var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "platform-login" },
    [
      _c(
        "el-carousel",
        { attrs: { interval: 2000, "indicator-position": "none" } },
        _vm._l(
          _vm.platformData.images
            ? _vm.platformData.images.split(",")
            : _vm.swiperList,
          function (item, index) {
            return _c(
              "el-carousel-item",
              {
                key: index,
                staticStyle: { cursor: "pointer" },
                attrs: { arrow: _vm.swiperList.length > 1 ? "hover" : "never" },
                nativeOn: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.jumpUrl(item)
                  },
                },
              },
              [
                _c("el-image", {
                  staticStyle: { width: "100%" },
                  attrs: { src: item.img || item, fit: "cover" },
                }),
              ],
              1
            )
          }
        ),
        1
      ),
      _c("div", { staticClass: "platform-content" }, [
        _c("div", { staticClass: "platform-title" }, [
          _vm._v(_vm._s(_vm.$t("platformLogin.interHospital"))),
        ]),
        _c(
          "div",
          { staticClass: "platform-btn" },
          _vm._l(_vm.platformLoginList, function (item, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "platform-box",
                on: {
                  click: function ($event) {
                    return _vm.handleJump(item)
                  },
                },
              },
              [_vm._v(_vm._s(item.name))]
            )
          }),
          0
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }